function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import ButtonLinkComponent from "components/core/button-link/button-link-component";
import LottieAnimationComponent from "../lottie-animtaion/lottie-animation-component";
import { StyledButtonWithAnimationComponent } from "./button-with-animation-component.scss";
let INITIAL_LOTTIE_ANIMATION_CONFIG = {
    animation: {
        jsonPath: "/static/lottie/arrow-swirl-left.json",
        loop: false,
        autoplay: false,
        playOnlyWhenVisible: true
    },
    style: {
        height: "100%"
    }
};
const FIRE_ACTION_FRAME = 27;
class ButtonWithAnimationComponent extends PureComponent {
    bounceSignup() {
        if (this.state.animated) return;
        this.setState({
            animated: true
        }, ()=>{
            setTimeout(()=>{
                this.setState({
                    animated: false
                });
            }, 2000);
        });
    }
    getLottieConfig(color) {
        let lottieConfig = _object_spread({}, INITIAL_LOTTIE_ANIMATION_CONFIG);
        lottieConfig.style = _object_spread_props(_object_spread({}, lottieConfig.style), {
            color
        });
        return lottieConfig;
    }
    render() {
        const { lottie, withAnimation, button, direction, textColor } = this.props;
        const lottieConfig = this.getLottieConfig(textColor);
        return /*#__PURE__*/ _jsx(StyledButtonWithAnimationComponent, {
            className: classnames("button-with-animation-component", {
                [direction]: direction
            }),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "inline-flex-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("button-wrapper", {
                            "bounce-button": this.state.animated
                        }),
                        children: /*#__PURE__*/ _jsx(ButtonLinkComponent, _object_spread_props(_object_spread({}, button), {
                            children: button.text
                        }))
                    }),
                    withAnimation && /*#__PURE__*/ _jsx("div", {
                        className: "lottie-animation-wrapper",
                        children: /*#__PURE__*/ _jsx(LottieAnimationComponent, _object_spread({}, lottieConfig))
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        this.bounceSignup = this.bounceSignup.bind(this);
        INITIAL_LOTTIE_ANIMATION_CONFIG.fireActionOnFrame = {
            frame: FIRE_ACTION_FRAME,
            action: this.bounceSignup
        };
        this.state = {
            animated: false
        };
    }
}
export { ButtonWithAnimationComponent as default };
ButtonWithAnimationComponent.defaultProps = {
    button: {
        color: "brand-dark-blue",
        href: "/help",
        text: "Contact Us",
        fontSize: "16px",
        textColor: "white"
    },
    withAnimation: true
};
